<template>
  <div class="planificaciones-mobile">
    <!-- Header simplificado -->
    <div class="mobile-header">
       <div class="user-info">
        <div class="user-avatar">
          {{ usuario.nombre ? usuario.nombre.charAt(0) : '' }}{{ usuario.apellido ? usuario.apellido.charAt(0) : '' }}
        </div>
        <div class="user-details">
          <span class="user-name">{{ usuario.nombre }} {{ usuario.apellido }}</span>

        </div>
      </div>
      <div class="header-top">
        <h1 class="page-title">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
          Mis Planificaciones
        </h1>
        <div class="header-actions">
          <button @click="cerrarSesion" class="btn-logout-header" title="Cerrar Sesión">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </button>
          <button @click="abrirModalAgregar" class="btn-add-mobile" title="Agregar planificación">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
            </svg>
          </button>
        </div>

      </div>



      <!-- Selector de fechas simplificado -->
      <div class="date-selector">
        <button @click="navegarFechaAnterior" class="btn-nav-date">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <div class="current-date">
          <span class="fecha">{{ fechaActualFormateada }}</span>
          <span class="dia-semana">{{ diaSemanaActual }}</span>
        </div>

        <button @click="navegarFechaSiguiente" class="btn-nav-date">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      <!-- Mini selector de días anteriores -->
      <div class="mini-calendario">
        <button v-for="(dia, index) in diasAnteriores" :key="index" @click="seleccionarFecha(dia.fecha)"
          :class="['dia-btn', { 'dia-activo': dia.fecha === fechaSeleccionada }]">
          <span class="dia-nombre">{{ dia.nombre }}</span>
          <span class="dia-numero">{{ dia.numero }}</span>
        </button>
      </div>

      <!-- Chips de filtros por estado -->
      <div class="estado-chips">
        <button v-for="estado in estadosDisponibles" :key="estado.valor" @click="toggleFiltroEstado(estado.valor)"
          :class="['chip-estado', `chip-${estado.clase}`, { 'chip-activo': filtroEstado === estado.valor }]">
          <span class="chip-dot"></span>
          <span class="chip-label">{{ estado.nombre }}</span>
          <span class="chip-count">{{ estado.contador }}</span>
        </button>
      </div>
    </div>

    <!-- Lista de actividades -->
    <div class="activities-list">
      <div v-if="cargando" class="loading-state">
        <div class="spinner"></div>
        <p>Cargando planificaciones...</p>
      </div>

      <div v-else-if="actividadesFiltradas.length === 0" class="empty-state">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        <h3>No hay planificaciones</h3>
        <p>Agrega tu primera planificación para comenzar</p>
        <button @click="abrirModalAgregar" class="btn-add-first">
          Agregar Planificación
        </button>
      </div>

      <div v-else class="activities-container">
        <div v-for="actividad in actividadesFiltradas" :key="actividad.id"
          :class="['activity-card-mobile', 'card-' + obtenerClaseEstado(actividad.estado)]"
          @click="verDetalle(actividad)">
          <div class="card-header-mobile">
            <span :class="['estado-badge', 'badge-' + obtenerClaseEstado(actividad.estado)]">
              <span class="badge-dot"></span>
              {{ actividad.estado }}
            </span>

            <!-- Botones de acción más grandes y precisos -->
            <div class="acciones-card">
              <!-- Botón Iniciar Visita (mejorado) -->
              <button v-if="actividad.estadoNumerico == 0 && !actividad.latitud"
                @click.stop="registrarUbicacionDesdeCard(actividad, 'inicio')" class="btn-accion-card btn-iniciar"
                title="Iniciar Visita">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span class="btn-text">Iniciar</span>
              </button>

              <!-- Botón Finalizar Visita (mejorado) -->
              <button v-if="actividad.latitud && !actividad.latitud_fin && actividad.estadoNumerico == 0"
                @click.stop="registrarUbicacionDesdeCard(actividad, 'fin')" class="btn-accion-card btn-finalizar"
                title="Finalizar Visita">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                </svg>
                <span class="btn-text">Finalizar</span>
              </button>

              <!-- Menú de opciones (también mejorado) -->
              <div class="dropdown-container" @click.stop>
                <button @click.stop="toggleMenu(actividad.id)" class="btn-menu-mobile" title="Más opciones">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                  </svg>
                </button>
                <transition name="dropdown-fade">
                  <div v-if="menuActivo === actividad.id" class="dropdown-menu-mobile">
                    <button @click.stop="editarActividad(actividad)" class="dropdown-item">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                      <span>Editar</span>
                    </button>
                    <button v-if="actividad.estadoNumerico == 0" @click.stop="confirmarNoRealizada(actividad)"
                      class="dropdown-item dropdown-item-norealizada">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                      </svg>
                      <span>No Realizada</span>
                    </button>
                    <button v-if="actividad.estadoNumerico == 0" @click.stop="confirmarEliminar(actividad)"
                      class="dropdown-item dropdown-item-delete">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                      <span>Eliminar</span>
                    </button>
                  </div>
                </transition>
              </div>
            </div>
          </div>

          <div class="card-content">
            <h3 class="escuela-nombre">{{ actividad.asignado }}</h3>
            <p class="actividad-titulo">{{ actividad.titulo }}</p>
            <p class="actividad-descripcion">{{ actividad.descripcion || 'Sin observaciones' }}</p>
            <!-- {{ actividad }} -->

            <div class="actividad-meta">
              <span class="meta-hora">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                {{ actividad.hora || 'Sin hora' }}
              </span>
            </div>

            <!-- Indicadores de ubicación -->
            <div class="ubicacion-indicadores">
              <span :class="['ubicacion-badge', actividad.latitud ? 'ubicacion-ok' : 'ubicacion-pendiente']">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                </svg>
                Inicio: {{ actividad.latitud ? '✓' : '○' }}
              </span>
              <span :class="['ubicacion-badge', actividad.latitud_fin ? 'ubicacion-ok' : 'ubicacion-pendiente']">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                </svg>
                Fin: {{ actividad.latitud_fin ? '✓' : '○' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para agregar/editar planificación (reutilizado del original pero simplificado) -->
    <PlanificacionFormModal :visible="modalAbierto" :modo-edicion="modoEdicion" :usuario="usuario"
      :planificacion="planificacionSeleccionada" @close="cerrarModal" @save="guardarPlanificacion" />

    <!-- Modales de confirmación -->
    <ConfirmModal :visible="popupConfirmDelete" titulo="Confirmar Eliminación"
      mensaje="¿Está seguro de eliminar esta planificación?" tipo="danger" @confirm="ejecutarEliminar"
      @cancel="popupConfirmDelete = false" />

    <ConfirmModal :visible="popupConfirmNoRealizada" titulo="Marcar como No Realizada"
      mensaje="¿Está seguro de marcar esta planificación como no realizada?" tipo="warning"
      @confirm="ejecutarNoRealizada" @cancel="popupConfirmNoRealizada = false" />

    <!-- Modal para ingresar descripción al finalizar la visita -->
    <vs-popup class="popup-descripcion" title="Descripción de la visita" :active.sync="mostrarModalDescripcion">
      <div class="descripcion-modal-body">
        <p class="descripcion-modal-subtitle">Para finalizar la visita, puedes agregar comentarios adicionales o detalles sobre la visita
          realizada:</p>
        <vs-textarea v-model="descripcionModal" class="descripcion-textarea"
          placeholder="Escribe aquí la descripción de la visita..." rows="5" autofocus></vs-textarea>
        <div class="descripcion-modal-actions">
          <vs-button @click="finalizarConDescripcion" color="success" type="gradient" block>
            Finalizar Visita
          </vs-button>
          <vs-button @click="mostrarModalDescripcion = false" color="danger" type="border" block>
            Cancelar
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import PlanificacionFormModal from './PlanificacionFormModal.vue'
import ConfirmModal from './ConfirmModal.vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ScreenPlanificacionesAgenda',
  components: {
    PlanificacionFormModal,
    ConfirmModal
  },
  props: {
    usuarioExterno: {
      type: Object,
      default: null
    }
  },
  data() {
    const hoy = new Date()
    const formatFecha = (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }

    return {
      cargando: false,
      modalAbierto: false,
      modoEdicion: false,
      usuario: null,
      fechaSeleccionada: formatFecha(hoy),
      filtroEstado: null, // null = todos
      menuActivo: null,
      popupConfirmDelete: false,
      popupConfirmNoRealizada: false,
      actividadSeleccionada: null,
      actividades: [],
      diasAnteriores: this.generarDiasAnteriores(hoy),
      // Nuevas variables para el modal de descripción
      mostrarModalDescripcion: false,
      descripcionModal: '',
      actividadPendiente: null
    }
  },
  computed: {
    ...mapState('planificaciones', ['actividades']),

    fechaActualFormateada() {
      const fecha = new Date(this.fechaSeleccionada + 'T00:00:00')
      const opciones = { day: '2-digit', month: 'long', year: 'numeric' }
      return fecha.toLocaleDateString('es-ES', opciones)
    },

    diaSemanaActual() {
      const fecha = new Date(this.fechaSeleccionada + 'T00:00:00')
      const opciones = { weekday: 'long' }
      return fecha.toLocaleDateString('es-ES', opciones)
    },

    actividadesFiltradas() {
      let resultado = this.actividades.filter(act => act.fecha === this.fechaSeleccionada)

      if (this.filtroEstado) {
        resultado = resultado.filter(act => act.estado === this.filtroEstado)
      }

      return resultado.sort((a, b) => (a.hora || '').localeCompare(b.hora || ''))
    },

    estadosDisponibles() {
      const actividadesFecha = this.actividades.filter(act => act.fecha === this.fechaSeleccionada)

      return [
        { valor: 'Generada', nombre: 'Generadas', clase: 'generada', contador: actividadesFecha.filter(a => a.estado === 'Generada').length },
        { valor: 'Registrada', nombre: 'Registradas', clase: 'registrada', contador: actividadesFecha.filter(a => a.estado === 'Registrada').length },
        { valor: 'Eliminado', nombre: 'Anuladas', clase: 'eliminado', contador: actividadesFecha.filter(a => a.estado === 'Eliminado').length },
        { valor: 'No Realizada', nombre: 'No Realizadas', clase: 'norealizada', contador: actividadesFecha.filter(a => a.estado === 'No Realizada').length }
      ]
    },

    planificacionSeleccionada() {
      return this.actividadSeleccionada
    }
  },
  methods: {
    ...mapActions('planificaciones', ['cargarActividades', 'guardarActividad', 'eliminarActividad', 'cambiarEstadoActividad']),

    determinarUsuario() {
      let me = this

      if (me.usuarioExterno) {
        me.usuario = {
          idusuario: me.usuarioExterno.idusuario,
          cedula: me.usuarioExterno.cedula,
          nombre: me.usuarioExterno.nombres || me.usuarioExterno.name_usuario,
          apellido: me.usuarioExterno.apellidos
        }
        return
      }

      if (this.$route.path === '/asesor/planificaciones') {
        const userPlanificaciones = localStorage.getItem('userPlanificaciones')
        if (userPlanificaciones) {
          try {
            const user = JSON.parse(userPlanificaciones)
            me.usuario = {
              idusuario: user.idusuario,
              cedula: user.cedula,
              nombre: user.nombres || user.name_usuario,
              apellido: user.apellidos
            }
            return
          } catch (error) {
            console.error('Error al parsear userPlanificaciones:', error)
          }
        }
      }

      const usuarioPlataforma = localStorage.getItem('usuario')
      if (usuarioPlataforma) {
        try {
          me.usuario = JSON.parse(usuarioPlataforma)
        } catch (error) {
          console.error('Error al parsear usuario de plataforma:', error)
        }
      }
    },
    cerrarSesion() {
      this.$emit('logout')
    },
    generarDiasAnteriores(fecha) {
      const dias = []
      const fechaBase = new Date(fecha)

      for (let i = 4; i >= 0; i--) {
        const dia = new Date(fechaBase)
        dia.setDate(fechaBase.getDate() - i)

        dias.push({
          fecha: dia.toISOString().split('T')[0],
          nombre: dia.toLocaleDateString('es-ES', { weekday: 'short' }).replace('.', ''),
          numero: dia.getDate()
        })
      }
      return dias
    },

    navegarFechaAnterior() {
      const fecha = new Date(this.fechaSeleccionada + 'T00:00:00')
      fecha.setDate(fecha.getDate() - 1)
      this.fechaSeleccionada = fecha.toISOString().split('T')[0]
      this.diasAnteriores = this.generarDiasAnteriores(fecha)
    },

    navegarFechaSiguiente() {
      const fecha = new Date(this.fechaSeleccionada + 'T00:00:00')
      fecha.setDate(fecha.getDate() + 1)
      this.fechaSeleccionada = fecha.toISOString().split('T')[0]
      this.diasAnteriores = this.generarDiasAnteriores(fecha)
    },

    seleccionarFecha(fecha) {
      this.fechaSeleccionada = fecha
    },

    toggleFiltroEstado(estado) {
      if (this.filtroEstado === estado) {
        this.filtroEstado = null
      } else {
        this.filtroEstado = estado
      }
    },

    async cargarActividades() {
      this.cargando = true
      try {
        // Llamada a la API para cargar actividades del usuario
        const response = await this.$http.get(
          `${this.$server_url}agenda-planificacion?usuario_id=${this.usuario.idusuario}`
        )

        if (response.data.success) {
          this.actividades = response.data.data.map(item => this.mapearActividad(item))
        }
      } catch (error) {
        console.error('Error cargando actividades:', error)
        this.$vs.notify({
          title: 'Error',
          text: 'Error al cargar las planificaciones',
          color: 'danger'
        })
      } finally {
        this.cargando = false
      }
    },

    mapearActividad(item) {
      const opciones = JSON.parse(item.opciones || '{}')

      let fechaSolo = ''
      if (item.startDate) {
        fechaSolo = item.startDate.includes('T')
          ? item.startDate.split('T')[0]
          : item.startDate.substring(0, 10)
      }

      return {
        id: item.id,
        titulo: item.title,
        descripcion: item.url,
        fecha: fechaSolo,
        hora: item.hora_inicio,
        estado: this.obtenerEstadoTexto(item.estado),
        asignado: item.nombre_institucion || item.nombre_institucion_temporal || 'Sin institución',
        estadoNumerico: item.estado,
        opciones: opciones,
        latitud: item.latitud,
        longitud: item.longitud,
        fecha_captura_longitud: item.fecha_captura_longitud,
        latitud_fin: item.latitud_fin,
        longitud_fin: item.longitud_fin,
        fecha_captura_longitud_fin: item.fecha_captura_longitud_fin,
        institucion_id: item.institucion_id,
        institucion_id_temporal: item.institucion_id_temporal,
        estado_institucion_temporal: item.estado_institucion_temporal,
        periodo_id: item.periodo_id,
        nombre_institucion: item.nombre_institucion_temporal || item.nombre_institucion,
        datosCompletos: item
      }
    },

    obtenerEstadoTexto(estado) {
      const estados = { 0: 'Generada', 1: 'Registrada', 2: 'Eliminado', 3: 'No Realizada' }
      return estados[estado] || 'Desconocido'
    },

    obtenerClaseEstado(estado) {
      const clases = {
        'Generada': 'generada',
        'Registrada': 'registrada',
        'Eliminado': 'eliminado',
        'No Realizada': 'norealizada'
      }
      return clases[estado] || 'generada'
    },

    toggleMenu(actividadId) {
      this.menuActivo = this.menuActivo === actividadId ? null : actividadId
    },

    cerrarMenu() {
      this.menuActivo = null
    },

    abrirModalAgregar() {
      this.modoEdicion = false
      this.actividadSeleccionada = {
        fecha: this.fechaSeleccionada,
        hora: new Date().toTimeString().slice(0, 5),
        titulo: '',
        descripcion: '',
        institucion_id: null,
        institucion_id_temporal: null,
        nombre_institucion: '',
        estado_institucion_temporal: 0,
        opciones: {}
      }
      this.modalAbierto = true
    },

    verDetalle(actividad) {
      this.modoEdicion = true
      this.actividadSeleccionada = { ...actividad }
      this.modalAbierto = true
    },

    editarActividad(actividad) {
      this.menuActivo = null
      this.verDetalle(actividad)
    },

    cerrarModal() {
      this.modalAbierto = false
      this.actividadSeleccionada = null
    },

    async guardarPlanificacion(data) {
      console.log('Datos recibidos en guardarPlanificacion:', data)

      try {
        this.$vs.loading({ text: 'Guardando planificación...' })

        let response
        if (this.modoEdicion) {
          // Para edición, usar el ID que viene en los datos
          const id = data.id || this.actividadSeleccionada.id
          if (!id) {
            throw new Error('ID de planificación no encontrado')
          }

          console.log('Actualizando planificación ID:', id)
          console.log('FormData a enviar:', data.formData)

          response = await this.$http.post(
            `${this.$server_url}agenda-planificacion/${id}`,
            data.formData
          )
        } else {
          // Para nueva planificación
          response = await this.$http.post(
            `${this.$server_url}agenda-planificacion`,
            data.formData || data
          )
        }

        console.log('Respuesta del servidor:', response)

        if (response.data.success) {
          this.$vs.notify({
            title: 'Éxito',
            text: `Planificación ${this.modoEdicion ? 'actualizada' : 'creada'} exitosamente`,
            color: 'success'
          })
          this.cerrarModal()
          await this.cargarActividades()
        } else {
          throw new Error(response.data.message || 'Error al guardar la planificación')
        }
      } catch (error) {
        console.error('Error guardando planificación:', error)
        if (error.response) {
          console.error('Response error:', error.response.data)
        }
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.message || error.message || 'Error al guardar la planificación',
          color: 'danger'
        })
      } finally {
        this.$vs.loading.close()
      }
    },

    async registrarUbicacionDesdeCard(actividad, tipo) {
      // Para FINALIZAR visita, validar descripción primero
      if (tipo === 'fin') {
        if (!actividad.descripcion || actividad.descripcion.trim() === '') {
          // Guardar la actividad y el tipo para usarlos después
          this.actividadPendiente = {
            actividad: actividad,
            tipo: tipo
          };
          this.descripcionModal = '';
          this.mostrarModalDescripcion = true;
          return;
        }
      }

      // Proceder con el registro de ubicación
      await this.ejecutarRegistroUbicacion(actividad, tipo);
    },

    async ejecutarRegistroUbicacion(actividad, tipo) {
      if (!navigator.geolocation) {
        this.$vs.notify({
          title: 'Error',
          text: 'Tu navegador no soporta geolocalización',
          color: 'danger'
        })
        return
      }

      this.$vs.loading({ text: `Obteniendo ubicación de ${tipo}...` })

      const options = {
        enableHighAccuracy: true,
        timeout: 30000,
        maximumAge: 0
      }

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const formData = new FormData()

            // IMPORTANTE: Agregar _method para que Laravel lo interprete como PUT
            formData.append('_method', 'PUT')

            // Campos obligatorios
            formData.append('title', actividad.titulo)
            formData.append('startDate', actividad.fecha)
            formData.append('hora_inicio', actividad.hora || '00:00:00')
            formData.append('hora_fin', actividad.hora || '00:00:00')
            formData.append('endDate', actividad.fecha)
            formData.append('usuario_editor', this.usuario.idusuario)
            formData.append('estado', actividad.estadoNumerico || 0)

            // Opciones (si existen)
            if (actividad.opciones) {
              formData.append('opciones', JSON.stringify(actividad.opciones))
            } else {
              formData.append('opciones', '{}')
            }

            // Descripción
            if (actividad.descripcion) {
              formData.append('url', actividad.descripcion)
            }

            // Institución
            if (actividad.institucion_id) {
              formData.append('institucion_id', actividad.institucion_id)
              formData.append('estado_institucion_temporal', '0')
            }
            if (actividad.institucion_id_temporal) {
              formData.append('institucion_id_temporal', actividad.institucion_id_temporal)
              formData.append('nombre_institucion_temporal', actividad.nombre_institucion || actividad.asignado)
              formData.append('estado_institucion_temporal', '1')
            }
            if (actividad.periodo_id) {
              formData.append('periodo_id', actividad.periodo_id)
            }

            // Generar fecha/hora actual
            const ahora = new Date()
            const year = ahora.getFullYear()
            const month = String(ahora.getMonth() + 1).padStart(2, '0')
            const day = String(ahora.getDate()).padStart(2, '0')
            const hours = String(ahora.getHours()).padStart(2, '0')
            const minutes = String(ahora.getMinutes()).padStart(2, '0')
            const seconds = String(ahora.getSeconds()).padStart(2, '0')
            const fechaHora = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`

            // Agregar ubicación según el tipo
            if (tipo === 'inicio') {
              formData.append('latitud', position.coords.latitude.toString())
              formData.append('longitud', position.coords.longitude.toString())
              formData.append('fecha_captura_longitud', fechaHora)
            } else {
              formData.append('latitud_fin', position.coords.latitude.toString())
              formData.append('longitud_fin', position.coords.longitude.toString())
              formData.append('fecha_captura_longitud_fin', fechaHora)
            }

            console.log('Enviando ubicación - URL:', `${this.$server_url}agenda-planificacion/${actividad.id}`)
            console.log('Datos de ubicación:', {
              tipo: tipo,
              latitud: position.coords.latitude,
              longitud: position.coords.longitude,
              fecha: fechaHora
            })

            const response = await this.$http.post(
              `${this.$server_url}agenda-planificacion/${actividad.id}`,
              formData
            )

            if (response.data.success) {
              this.$vs.notify({
                title: 'Éxito',
                text: `Ubicación de ${tipo} registrada correctamente`,
                color: 'success'
              })
              await this.cargarActividades()
            } else {
              throw new Error(response.data.message || 'Error al registrar ubicación')
            }
          } catch (error) {
            console.error('Error completo:', error)
            if (error.response) {
              console.error('Response status:', error.response.status)
              console.error('Response data:', error.response.data)
            }

            let mensajeError = 'Error al registrar la ubicación'
            if (error.response && error.response.data && error.response.data.message) {
              mensajeError = error.response.data.message
            } else if (error.response && error.response.data && error.response.data.errors) {
              const errors = []
              for (let key in error.response.data.errors) {
                errors.push(...error.response.data.errors[key])
              }
              mensajeError = errors.join(', ')
            }

            this.$vs.notify({
              title: 'Error',
              text: mensajeError,
              color: 'danger'
            })
          } finally {
            this.$vs.loading.close()
          }
        },
        (error) => {
          this.$vs.loading.close()
          let mensajeError = 'No se pudo obtener la ubicación'
          switch (error.code) {
            case error.PERMISSION_DENIED:
              mensajeError = 'Permiso de ubicación denegado. Por favor, activa el GPS.'
              break
            case error.POSITION_UNAVAILABLE:
              mensajeError = 'Información de ubicación no disponible. Verifica que el GPS esté activado.'
              break
            case error.TIMEOUT:
              mensajeError = 'Tiempo de espera agotado. Intenta nuevamente en un lugar con mejor señal.'
              break
          }
          this.$vs.notify({ title: 'Error', text: mensajeError, color: 'danger' })
        },
        options
      )
    },

    async finalizarConDescripcion() {
      // if (!this.descripcionModal || this.descripcionModal.trim() === '') {
      //   this.$vs.notify({
      //     title: 'Validación',
      //     text: 'La descripción es obligatoria para finalizar la visita',
      //     color: 'warning'
      //   })
      //   return
      // }

      try {
        this.$vs.loading({ text: 'Guardando descripción...' })

        const formData = new FormData()
        formData.append('_method', 'PUT') // IMPORTANTE

        const actividad = this.actividadPendiente.actividad

        // Todos los campos obligatorios
        formData.append('title', actividad.titulo)
        formData.append('startDate', actividad.fecha)
        formData.append('hora_inicio', actividad.hora || '00:00:00')
        formData.append('hora_fin', actividad.hora || '00:00:00')
        formData.append('endDate', actividad.fecha)
        formData.append('usuario_editor', this.usuario.idusuario)
        formData.append('estado', actividad.estadoNumerico || 0)
        formData.append('url', this.descripcionModal)

        // Opciones
        if (actividad.opciones) {
          formData.append('opciones', JSON.stringify(actividad.opciones))
        } else {
          formData.append('opciones', '{}')
        }

        // Institución
        if (actividad.institucion_id) {
          formData.append('institucion_id', actividad.institucion_id)
          formData.append('estado_institucion_temporal', '0')
        }
        if (actividad.institucion_id_temporal) {
          formData.append('institucion_id_temporal', actividad.institucion_id_temporal)
          formData.append('nombre_institucion_temporal', actividad.nombre_institucion || actividad.asignado)
          formData.append('estado_institucion_temporal', '1')
        }
        if (actividad.periodo_id) {
          formData.append('periodo_id', actividad.periodo_id)
        }

        console.log('Guardando descripción - URL:', `${this.$server_url}agenda-planificacion/${actividad.id}`)

        const response = await this.$http.post(
          `${this.$server_url}agenda-planificacion/${actividad.id}`,
          formData
        )

        if (response.data.success) {
          actividad.descripcion = this.descripcionModal
          this.mostrarModalDescripcion = false
          this.$vs.loading.close()

          // Proceder con el registro de ubicación
          await this.ejecutarRegistroUbicacion(actividad, 'fin')
        } else {
          throw new Error(response.data.message || 'Error al guardar la descripción')
        }
      } catch (error) {
        console.error('Error guardando descripción:', error)
        this.$vs.loading.close()

        let mensajeError = 'Error al guardar la descripción'
        if (error.response && error.response.data && error.response.data.message) {
          mensajeError = error.response.data.message
        }

        this.$vs.notify({
          title: 'Error',
          text: mensajeError,
          color: 'danger'
        })
      } finally {
        this.actividadPendiente = null
        this.descripcionModal = ''
      }
    },

    confirmarEliminar(actividad) {
      this.menuActivo = null
      this.actividadSeleccionada = actividad
      this.popupConfirmDelete = true
    },

    async ejecutarEliminar() {
      try {
        this.$vs.loading({ text: 'Eliminando planificación...' })

        const response = await this.$http.delete(
          `${this.$server_url}agenda-planificacion/${this.actividadSeleccionada.id}`
        )

        if (response.data.success) {
          this.$vs.notify({
            title: 'Éxito',
            text: 'Planificación eliminada exitosamente',
            color: 'success'
          })
          await this.cargarActividades()
        }
      } catch (error) {
        console.error('Error eliminando:', error)
        this.$vs.notify({
          title: 'Error',
          text: 'Error al eliminar la planificación',
          color: 'danger'
        })
      } finally {
        this.$vs.loading.close()
        this.popupConfirmDelete = false
        this.actividadSeleccionada = null
      }
    },

    confirmarNoRealizada(actividad) {
      this.menuActivo = null
      this.actividadSeleccionada = actividad
      this.popupConfirmNoRealizada = true
    },

    async ejecutarNoRealizada() {
      try {
        this.$vs.loading({ text: 'Actualizando planificación...' })

        const response = await this.$http.post(
          `${this.$server_url}agenda-planificacion/${this.actividadSeleccionada.id}/cambiar-estado`,
          { estado: 3 }
        )

        if (response.data.success) {
          this.$vs.notify({
            title: 'Éxito',
            text: 'Planificación marcada como No Realizada',
            color: 'success'
          })
          await this.cargarActividades()
        }
      } catch (error) {
        console.error('Error actualizando:', error)
        this.$vs.notify({
          title: 'Error',
          text: 'Error al actualizar la planificación',
          color: 'danger'
        })
      } finally {
        this.$vs.loading.close()
        this.popupConfirmNoRealizada = false
        this.actividadSeleccionada = null
      }
    }
  },
  mounted() {
    this.determinarUsuario()
    if (this.usuario) {
      this.cargarActividades()
    }
    document.addEventListener('click', this.cerrarMenu)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.cerrarMenu)
  }
}
</script>

<style scoped>
.planificaciones-mobile {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

.mobile-header {
  background: white;
  padding: 1rem 1rem 0.75rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 10;
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.page-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.page-title svg {
  width: 1.5rem;
  height: 1.5rem;
  color: #2563eb;
}

.btn-add-mobile {
  width: 2.5rem;
  height: 2.5rem;
  border: none;
  border-radius: 50%;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.3);
}

.btn-add-mobile svg {
  width: 1.5rem;
  height: 1.5rem;
}

.date-selector {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8fafc;
  border-radius: 3rem;
  padding: 0.5rem;
  margin-bottom: 1rem;
}

.btn-nav-date {
  width: 2.5rem;
  height: 2.5rem;
  border: none;
  border-radius: 50%;
  background: white;
  color: #475569;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.btn-nav-date svg {
  width: 1.25rem;
  height: 1.25rem;
}

.current-date {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.current-date .fecha {
  font-weight: 700;
  font-size: 1rem;
  color: #0f172a;
}

.current-date .dia-semana {
  font-size: 0.75rem;
  color: #64748b;
  text-transform: capitalize;
}

.mini-calendario {
  display: flex;
  justify-content: space-around;
  margin-bottom: 1rem;
  padding: 0.25rem 0;
}

.dia-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  border: none;
  padding: 0.5rem 0.25rem;
  border-radius: 1rem;
  min-width: 3rem;
  cursor: pointer;
  transition: all 0.2s;
}

.dia-btn .dia-nombre {
  font-size: 0.7rem;
  color: #64748b;
  text-transform: uppercase;
}

.dia-btn .dia-numero {
  font-size: 1rem;
  font-weight: 600;
  color: #334155;
}

.dia-btn.dia-activo {
  background: #2563eb;
}

.dia-btn.dia-activo .dia-nombre,
.dia-btn.dia-activo .dia-numero {
  color: white;
}

.estado-chips {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  padding: 0.25rem 0 0.5rem;
  scrollbar-width: none;
  white-space: nowrap;
}

.estado-chips::-webkit-scrollbar {
  display: none;
}

.chip-estado {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 0.875rem;
  border: none;
  border-radius: 2rem;
  font-size: 0.75rem;
  font-weight: 600;
  background: white;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.chip-generada {
  color: #0369a1;
}

.chip-registrada {
  color: #065f46;
}

.chip-eliminado {
  color: #991b1b;
}

.chip-norealizada {
  color: #92400e;
}

.chip-dot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
}

.chip-generada .chip-dot {
  background: #3b82f6;
}

.chip-registrada .chip-dot {
  background: #10b981;
}

.chip-eliminado .chip-dot {
  background: #ef4444;
}

.chip-norealizada .chip-dot {
  background: #f59e0b;
}

.chip-activo {
  background: #0f172a;
  border-color: #0f172a;
  color: white;
}

.chip-activo .chip-dot {
  background: white;
}

.chip-count {
  margin-left: 0.125rem;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.2);
  padding: 0.125rem 0.375rem;
  border-radius: 1rem;
}

.activities-list {
  padding: 1rem;
  padding-bottom: 2rem;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 0;
  color: #64748b;
}

.spinner {
  width: 2.5rem;
  height: 2.5rem;
  border: 3px solid #e2e8f0;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 1rem;
  text-align: center;
  background: white;
  border-radius: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.empty-state svg {
  width: 3.5rem;
  height: 3.5rem;
  color: #cbd5e1;
  margin-bottom: 1rem;
}

.empty-state h3 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #334155;
  margin: 0 0 0.25rem;
}

.empty-state p {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0 0 1.5rem;
}

.btn-add-first {
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  border: none;
  border-radius: 2rem;
  color: white;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.activities-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.activity-card-mobile {
  background: white;
  border-radius: 1rem;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border-left: 4px solid;
  transition: transform 0.2s;
}

.activity-card-mobile:active {
  transform: scale(0.98);
}

.card-generada {
  border-left-color: #3b82f6;
}

.card-registrada {
  border-left-color: #10b981;
}

.card-eliminado {
  border-left-color: #ef4444;
}

.card-norealizada {
  border-left-color: #f59e0b;
}

.card-header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.estado-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.625rem;
  border-radius: 2rem;
  font-size: 0.675rem;
  font-weight: 600;
  background: #f1f5f9;
}

.badge-dot {
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
}

.badge-generada {
  background: #e0f2fe;
  color: #0369a1;
}

.badge-generada .badge-dot {
  background: #3b82f6;
}

.badge-registrada {
  background: #d1fae5;
  color: #065f46;
}

.badge-registrada .badge-dot {
  background: #10b981;
}

.badge-eliminado {
  background: #fee2e2;
  color: #991b1b;
}

.badge-eliminado .badge-dot {
  background: #ef4444;
}

.badge-norealizada {
  background: #fef3c7;
  color: #92400e;
}

.badge-norealizada .badge-dot {
  background: #f59e0b;
}

.acciones-card {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-accion-card {
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.btn-accion-card svg {
  width: 1rem;
  height: 1rem;
}

.btn-iniciar {
  color: #2563eb;
}

.btn-finalizar {
  color: #10b981;
}

.dropdown-container {
  position: relative;
}

.btn-menu-mobile {
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

.btn-menu-mobile svg {
  width: 1.25rem;
  height: 1.25rem;
  color: #64748b;
}

.dropdown-menu-mobile {
  position: absolute;
  top: 2.5rem;
  right: 0;
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  min-width: 150px;
  z-index: 20;
  overflow: hidden;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  font-size: 0.875rem;
  color: #334155;
  cursor: pointer;
  transition: background 0.15s;
}

.dropdown-item:hover {
  background: #f8fafc;
}

.dropdown-item svg {
  width: 1rem;
  height: 1rem;
}

.dropdown-item-norealizada {
  color: #d97706;
}

.dropdown-item-delete {
  color: #dc2626;
}

.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: all 0.15s;
}

.dropdown-fade-enter,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

.card-content {
  margin-top: 0.5rem;
}

.escuela-nombre {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.25rem;
}

.actividad-titulo {
  font-size: 0.875rem;
  font-weight: 600;
  color: #334155;
  margin: 0 0 0.125rem;
}

.actividad-descripcion {
  font-size: 0.75rem;
  color: #64748b;
  margin: 0 0 0.75rem;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.actividad-meta {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.meta-hora {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  color: #64748b;
}

.meta-hora svg {
  width: 0.875rem;
  height: 0.875rem;
}

.ubicacion-indicadores {
  display: flex;
  gap: 0.75rem;
  padding-top: 0.5rem;
  border-top: 1px solid #f1f5f9;
}

.ubicacion-badge {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  border-radius: 1rem;
  background: #f8fafc;
}

.ubicacion-badge svg {
  width: 0.75rem;
  height: 0.75rem;
}

.ubicacion-ok {
  color: #059669;
}

.ubicacion-pendiente {
  color: #b45309;
}
</style>

<style>
/* Estilos globales para modales */
.popup-planificacion,
.popup-confirm-delete {
  z-index: 50003 !important;
}

.popup-planificacion .vs-popup {
  max-width: 95% !important;
  margin: 0 auto !important;
  border-radius: 1rem !important;
}

.popup-planificacion .vs-popup--header {
  padding: 1rem !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.popup-planificacion .vs-popup--title {
  font-size: 1.1rem !important;
  font-weight: 700 !important;
}

.popup-planificacion .vs-popup--content {
  padding: 1rem !important;
  max-height: 80vh !important;
  overflow-y: auto !important;
}

/* ===== MEJORAS PARA BOTONES DE ACCIÓN ===== */
.acciones-card {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-accion-card {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  min-width: 4rem;
  height: 2.5rem;
  padding: 0 0.5rem;
  border: none;
  border-radius: 1.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  color: #475569;
  z-index: 5;
  /* Asegura que esté por encima de otros elementos */
}

.btn-accion-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.btn-accion-card:active {
  transform: translateY(0);
}

.btn-accion-card svg {
  width: 1.25rem;
  height: 1.25rem;
}

.btn-accion-card .btn-text {
  display: inline-block;
  font-size: 0.7rem;
}

/* Estilo específico para botón iniciar */
.btn-iniciar {
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  color: #0369a1;
  border: 1px solid #7dd3fc;
}

.btn-iniciar svg {
  color: #0284c7;
}

/* Estilo específico para botón finalizar */
.btn-finalizar {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
  color: #166534;
  border: 1px solid #86efac;
}

.btn-finalizar svg {
  color: #16a34a;
}

/* Menú de opciones mejorado */
.btn-menu-mobile {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border: none;
  border-radius: 1.5rem;
  background: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 5;
}

.btn-menu-mobile:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  background: #f8fafc;
}

.btn-menu-mobile svg {
  width: 1.25rem;
  height: 1.25rem;
  color: #64748b;
}

/* Ajuste para evitar que el clic en botones abra el modal */
.activity-card-mobile {
  position: relative;
}

.activity-card-mobile .acciones-card {
  position: relative;
  z-index: 5;
}

/* Asegura que los botones sean clickeables sin abrir el modal */
.acciones-card button,
.acciones-card .dropdown-container {
  position: relative;
  z-index: 20;
  pointer-events: auto;
}

/* Ajuste para pantallas muy pequeñas */
@media (max-width: 480px) {
  .btn-accion-card {
    min-width: 3.5rem;
    height: 2.2rem;
    padding: 0 0.3rem;
  }

  .btn-accion-card svg {
    width: 1rem;
    height: 1rem;
  }

  .btn-accion-card .btn-text {
    font-size: 0.65rem;
  }

  .btn-menu-mobile {
    width: 2.2rem;
    height: 2.2rem;
  }

  .btn-menu-mobile svg {
    width: 1rem;
    height: 1rem;
  }
}

/* Asegurar que el dropdown esté por encima de todo */
.dropdown-container {
  position: relative;
  z-index: 30;
}

.dropdown-menu-mobile {
  position: absolute;
  top: 2.8rem;
  right: 0;
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  min-width: 160px;
  z-index: 100;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-logout-header {
  width: 2.5rem;
  height: 2.5rem;
  border: none;
  border-radius: 50%;
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-logout-header:hover {
  background: rgba(239, 68, 68, 0.2);
  transform: translateY(-2px);
}

.btn-logout-header svg {
  width: 1.25rem;
  height: 1.25rem;
}
/* Información del usuario - Versión mejorada */
.user-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.875rem 1.25rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 1rem;
  margin-bottom: 1.25rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(226, 232, 240, 0.6);
  position: relative;
  overflow: hidden;
}

.user-info::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  border-radius: 4px 0 0 4px;
}

.user-avatar {
  width: 3rem;
  height: 3rem;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 1.2rem;
  text-transform: uppercase;
  box-shadow: 0 6px 12px rgba(37, 99, 235, 0.25);
  border: 2px solid white;
  transition: transform 0.2s ease;
}

.user-avatar:hover {
  transform: scale(1.05);
}

.user-details {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.user-name {
  font-weight: 700;
  font-size: 1.1rem;
  color: #0f172a;
  line-height: 1.4;
  letter-spacing: -0.01em;
}

.user-role {
  font-size: 0.8rem;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin-top: 0.15rem;
}

.user-role::before {
  content: '';
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  background: #10b981;
  border-radius: 50%;
  margin-right: 0.25rem;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Ajustes responsive */
@media (max-width: 480px) {
  .user-info {
    padding: 0.7rem 1rem;
    gap: 0.75rem;
    margin-bottom: 1rem;
  }

  .user-avatar {
    width: 2.5rem;
    height: 2.5rem;
    font-size: 1rem;
    box-shadow: 0 4px 8px rgba(37, 99, 235, 0.2);
  }

  .user-name {
    font-size: 0.95rem;
  }

  .user-role {
    font-size: 0.7rem;
  }

  .user-role::before {
    width: 0.4rem;
    height: 0.4rem;
  }
}

/* Pantallas muy pequeñas */
@media (max-width: 360px) {
  .user-info {
    padding: 0.6rem 0.875rem;
  }

  .user-avatar {
    width: 2.2rem;
    height: 2.2rem;
    font-size: 0.9rem;
  }

  .user-name {
    font-size: 0.85rem;
  }
}
</style>
